module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/localization-box/localization-box.component.scss
// module id = ./src/app/modules/base-module/components/localization-box/localization-box.component.scss
// module chunks = 9